import { transformedAttributeList } from '../transforms/attribute';
import { CATEGORY_LEVEL } from '../enums/category';

export const getCategoryLevel = (categoryParent = null) => {
	if (categoryParent) {
		if (categoryParent.parent) {
			return {
				level: CATEGORY_LEVEL.THREE,
				parentLevelOneId: categoryParent.parent.id || null,
				parentLevelTwoId: categoryParent.id || null,
			};
		}
		return {
			level: CATEGORY_LEVEL.TWO,
			parentLevelOneId: categoryParent.id || null,
			parentLevelTwoId: null,
		};
	}
	return {
		level: CATEGORY_LEVEL.ONE,
		parentLevelOneId: null,
		parentLevelTwoId: null,
	};
};

export const transformedCategory = (category) => {
	const categoryData = category || {};
	const children = categoryData.children || [];
	const seo = categoryData.seo || {};
	const attributeKeys = categoryData.attribute_keys || [];
	const levelData = getCategoryLevel(categoryData.parent);

	return {
		id: categoryData.id || null,
		slug: categoryData.slug || null,
		name: categoryData.name || categoryData.name_en || null,
		nameTH: categoryData.name_th || null,
		commission: categoryData.commission || null,
		status: !!(categoryData.is_active || false),
		visibility: !!(categoryData.is_visible || false),
		descriptionTop: categoryData.description_top || null,
		descriptionBottom: categoryData.description_bottom || null,
		bannerImage: null,
		bannerLink: categoryData.banner_link || null,
		bannerVisibility: false, // TODO: use real data from API
		seo: {
			title: seo.title_en || null,
			titleTH: seo.title_th || null,
			keyword: seo.keyword_en || null,
			keywordTH: seo.keyword_th || null,
			description: seo.description_en || null,
			descriptionTH: seo.description_th || null,
		},
		attributeKeys: transformedAttributeList(attributeKeys),
		hasChild: children.length > 0,
		children: children.map(transformedCategory),
		level: levelData.level,
		parentLevelOneId: levelData.parentLevelOneId,
		parentLevelTwoId: levelData.parentLevelTwoId,
	};
};

export const transformedCategories = (categories = []) => {
	return categories.map((cate) => transformedCategory(cate));
};